import { Presenter, IPresenterOwner } from 'wdc-cube'
import { IFilterScope } from '../tcm_scopes'

export interface FilterPaneOwner extends IPresenterOwner {
    readonly owner: { fetchData(source: ''): Promise<unknown> }
}

export abstract class FilterPresenter<
    S extends IFilterScope,
    OWNER extends IPresenterOwner = IPresenterOwner
> extends Presenter<S, OWNER> {
    abstract clear(): void
    abstract publish(): void

    protected abstract bindEvents(): Promise<void>

    protected mostrarItemAdicionado(): void {
        this.scope.expanded = true
    }

    async prepare(order: number, label: string, visible = true): Promise<void> {
        this.scope.order = order
        this.scope.visible = visible
        this.scope.caption = label
        this.scope.onExpandedChange = this.action(this.handleExpandedChange)
        await this.bindEvents()
    }

    private async handleExpandedChange(expanded: boolean): Promise<void> {
        this.scope.expanded = expanded
    }
}
